import React from 'react';
import RadioGroup, { Radio } from '../../../../../../../components/RadioGroup';

import '../../Config/styles.css';

const Filters = ({
  comparativeUnit,
  comparativeUnits,
  changeComparativeUnit,
  comparativeType,
  comparativeTypes,
  changeComparativeType,
  viewType,
  viewTypes,
  changeviewType,
}) => {
  return (
    <div className="DashboardCompletedConfig__container">
      <div className="DashboardCompletedConfig__content">
        <div className="DashboardCompletedConfig__section">
          <div className="DashboardCompletedConfig__label">Valores do gráfico:</div>
          <RadioGroup
            compact
            value={comparativeUnit}
            onChangeValue={changeComparativeUnit}
          >
            <Radio value={comparativeUnits.PERFORMANCE} label="Performance" />
            <Radio value={comparativeUnits.VALUE} label="Valor" />
            <Radio value={comparativeUnits.WEIGHT} label="Peso" />
          </RadioGroup>
        </div>
        <div className="DashboardCompletedConfig__section">
          <div className="DashboardCompletedConfig__label">Ver números por:</div>
          <RadioGroup
            compact
            value={comparativeType}
            onChangeValue={changeComparativeType}
          >
            <Radio value={comparativeTypes.UF} label="Estados" />
            <Radio value={comparativeTypes.REGION} label="Regiões" />
          </RadioGroup>
        </div>
        <div className="DashboardCompletedConfig__section">
          <div className="DashboardCompletedConfig__label">Visão de gráfico:</div>
          <RadioGroup
            compact
            value={viewType}
            onChangeValue={changeviewType}
          >
            <Radio value={viewTypes.MAP} label="Mapa" />
            <Radio value={viewTypes.LIST} label="Lista" />
          </RadioGroup>
        </div>
      </div>
    </div>
  );
};

export default Filters;
